// Master Queries

import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery, axiosBaseQuery } from "../baseQuery";
import { getEmailTemplateMaster } from "../../graphql";
import API_ENDPOINTS from "../../apiEndpoints";

export const emailMasterTemplateApi = createApi({
  reducerPath: "EmailMasterData",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    fetchEmailTemplateMasterData: builder.query({
      query: (variables) => ({ body: getEmailTemplateMaster, variables }),
      keepUnusedDataFor: Infinity,
      refetchOnMountOrArgChange: true,
      providesTags: ["EmailTemplateMasterData"],
    }),
  }),
});

export const { useFetchEmailTemplateMasterDataQuery } = emailMasterTemplateApi;

export const emailMasterApi = createApi({
  reducerPath: "EmailMaster",
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    fetchEmailMasterData: builder.query({
      query: (data) => ({
        url: API_ENDPOINTS.REACT_APP_EMAIL_SETTING_URL,
        method: "GET",
        data,
      }),
      keepUnusedDataFor: Infinity,
      refetchOnMountOrArgChange: true,
      providesTags: ["EmailMasterData"],
    }),
    createEmailMasterData: builder.mutation({
      query: (data) => ({
        url: API_ENDPOINTS.REACT_APP_EMAIL_SETTING_URL,
        method: "POST",
        data,
      }),
      invalidatesTags: ["EmailMasterData"],
    }),
  }),
});

export const {
  useFetchEmailMasterDataQuery,
  useCreateEmailMasterDataMutation,
} = emailMasterApi;
